import EventBus from "common/eventbus";
import Events from "common/events";
import "./product-details-gang-sheet-discount.scss";

const $bulkTableContainer = () => document.querySelector(".js-pdp-bulk-discount-summary");
const $bulkTable = () => document.querySelector(".js-pdp-bulk-discount-summary-table");

const updateBulkTable = ({ target }) => {
  const $container = $bulkTableContainer();

  if ($container && $bulkTable()) {
    $container.innerHTML = target.htmlTable;
    $bulkTable().classList.remove("hidden");
  }
};

export default () => {
  EventBus.on(Events.BULK_TABLE_UPDATE, updateBulkTable);
};
